import React from 'react'
import AdministrationPanel from "../components/Administration/AdministrationPanel";
import { connect } from 'react-redux';

class Administration extends React.Component
{
    render() {
        return(
            <div>
                {this.props.isAdmin ? <AdministrationPanel /> : 'You have no permissions to access this site'}
            </div>
            
        );
    }
}

const mapStateToProps = state => ({
    isAdmin: state.user.isAdmin
})

export default connect(mapStateToProps, null)(Administration);


// WEBPACK FOOTER //
// ./src/pages/Administration.js